import { DonorAction, MenuLocation, PatientType } from '@nkr/enums/index';
import { DonorActions } from '../../donor-actions';
import { Dropdown, MenuItem } from 'react-bootstrap';
import OverlayMenuButton from '@nkr/components/overlay-menu-button';
import ReactHtmlParser from 'react-html-parser';

const menuItemList = [
    { action: DonorAction.Edit, title: 'Edit' },
    { action: DonorAction.Delete, title: 'Delete' },
    { action: DonorAction.ConvertDonorType, title: 'Convert Donor Type' },
    { action: DonorAction.OrderTissueTyping, title: 'Order High Res Tissue Typing (Cheek Swab)' },
    { action: DonorAction.UtilizeBulkCheekSwabKit, title: 'Utilize a Bulk Cheek Swab (Kit On-hand)' },
    { action: DonorAction.Voucher, title: 'Voucher Holders' },
    { action: DonorAction.AddMicrositeVoucherHolder, title: 'Add Microsite Voucher Holder' },
    { action: DonorAction.SendEmail, title: 'Send Voucher Self-Registration E-mail' },
    { action: DonorAction.SeeDash, title: 'See DASH Registration' },
    { action: DonorAction.Apply, title: 'Apply for Donor Shield Reimbursement' },
    { action: DonorAction.View, title: 'View' },
    { action: DonorAction.VoucherRecipient, title: 'Voucher Recipient' },
    { action: DonorAction.PrintRequisition, title: 'Reprint Donor Requisition' },
    { action: DonorAction.StartExpertSystem, title: 'Start Expert System' },
    { action: -1, title: '' }
];

const handlers = {
    [DonorAction.Edit]: DonorActions.handleDonorEdit,
    [DonorAction.Voucher]: DonorActions.handleVoucherHolders,
    [DonorAction.SeeDash]: DonorActions.handleSeeDash,
    [DonorAction.Apply]: DonorActions.handleApply,
    [DonorAction.VoucherRecipient]: DonorActions.handleVoucherRecipient,
};

interface IProps {
    donorId: number,
    centerId: number,
    donorCenterId: number,
    donationCenterId?: number,
    canDelete: boolean,
    canConvert: boolean,
    isAdp: boolean,
    donorType?: string,
    statusId: number,
    wageAndTravelRequested: boolean,
    registrationId: number,
    recipientId: number,
    recipientCenterId: number,
    recipientType: PatientType,
    isAdmin: boolean,
    isSuper: boolean,
    menuLocation: MenuLocation,
    canOrderCheekSwab: boolean,
    orderId: number,
    isExpertSystemParticipant?: boolean,
    isInExpertSystem?: boolean,
    onMenuToggle: (show: boolean) => void,
    onMenuDisplayed?: (id: number) => void,
    onItemSelectedInList?: (id: number, action: DonorAction) => void,
    onItemSelected?: (action: DonorAction) => void
}

const ActionButtonRenderer = (props: IProps) => {
    const handleMenuToggle = (show: boolean) => {
        props.onMenuToggle(show);
    };

    const itemHandler = (action: number) => {
        switch (action) {
            case DonorAction.SeeDash: return handlers[action](props.registrationId, props.donorCenterId);
            case DonorAction.VoucherRecipient: return handlers[action](props.recipientId, props.recipientCenterId);
            case DonorAction.Apply: return handlers[action](props.donorId, props.donationCenterId ?? props.donorCenterId);
            default: return handlers[action](props.donorId, props.donorCenterId);
        }
    };

    const handleMenuSelection = (id: any, action: number) => {
        if (handlers.hasOwnProperty(action)) {
            itemHandler(action);
        }

        props.onItemSelectedInList(id, action);
    };

    const handleSideBarMenuSelection = (e: any) => {
        let action = parseInt(e);

        if (handlers.hasOwnProperty(action)) {
            itemHandler(action);
        }

        props.onItemSelected(e);
    };

    if (props.donorId == null)
        return null;

    const getUrl = (action: DonorAction, id: number) => {
        let hrefPrefix = !props.isAdmin ? `/center/${props.centerId}` : `/center/${props.donorCenterId}`;

        switch (action) {
            case DonorAction.Edit: return `${hrefPrefix}/donor/${id}/profile`;
        }
    }

    const getMenuItems = () => {
        const data = props;

        let menuItems = [];

        menuItems.push(DonorAction.Edit);

        if (data.canDelete) {
            menuItems.push(DonorAction.Delete);
        }

        if (data.canConvert || props.isSuper) {
            menuItems.push(DonorAction.ConvertDonorType);
        }

        menuItems.push(DonorAction.Divider);

        if (props.canOrderCheekSwab) {
            menuItems.push(DonorAction.OrderTissueTyping);
        }


        if (data.orderId > 0) {
            menuItems.push(DonorAction.PrintRequisition);
        } else {
            menuItems.push(DonorAction.UtilizeBulkCheekSwabKit);
        }

        if (data.isAdp) {
            menuItems.push(DonorAction.Divider);
            menuItems.push(DonorAction.Voucher);
        }
        if (props.donorType == 'FV' || props.donorType == 'NDD') {
            menuItems.push(DonorAction.AddMicrositeVoucherHolder);
        }

        if (data.isAdp) {
            menuItems.push(DonorAction.SendEmail);
        }

        menuItems.push(DonorAction.Divider);

        if (data.registrationId > 0) {
            menuItems.push(DonorAction.SeeDash);
        }

        if (data.wageAndTravelRequested == false) {
            menuItems.push(DonorAction.Apply);
        }

        if (props.menuLocation == MenuLocation.List) {
            menuItems.push(DonorAction.Divider);
            menuItems.push(DonorAction.View)
        }

        if (props.recipientType == PatientType.StandardVoucherHolder || props.recipientType == PatientType.FamilyVoucherHolder) {
            if ((props.recipientId > 0 && props.recipientCenterId == props.centerId) || (props.recipientId > 0 && props.isSuper)) {
                menuItems.push(DonorAction.Divider);
                menuItems.push(DonorAction.VoucherRecipient);
            }
        }

        if (props.isExpertSystemParticipant && !props.isInExpertSystem && props.registrationId > 0) {
            menuItems.push(DonorAction.Divider);
            menuItems.push(DonorAction.StartExpertSystem);
        }

        return menuItems;
    }

    const menuItems = getMenuItems().map(item => {
        return menuItemList.find(x => x.action == item);
    });

    const menu = menuItems.map(item => {
        let url = item.action != -1 ? getUrl(item.action, props.donorId) : null;
        let id = item.action >= 0 ? props.donorId : 'div-' + props.donorId + '-' + Math.random() * 10000;

        if (url == null) {
            if (item.action >= 0) {
                return { id, action: item.action, include: true, selectable: true, url, element: <div>{ReactHtmlParser(item.title.replace(/ /g, '&nbsp;'))}</div> };
            } else {
                return { id, action: item.action, include: true, selectable: false, url, element: <div style={{ height: 10 }}></div>, divider: true };
            }
        } else {
            return { id, action: item.action, include: true, selectable: false, url, element: <a href={url}>{ReactHtmlParser(item.title.replace(/ /g, '&nbsp;'))}</a> };
        }
    });

    if (props.menuLocation == MenuLocation.Sidebar || props.menuLocation == MenuLocation.Profile) {
        return (
            <Dropdown id={`action-menu-${props.donorCenterId}`} onSelect={handleSideBarMenuSelection} style={{ width: '100%' }} pullRight>
                <Dropdown.Toggle style={{ width: '100%' }} bsSize={props.menuLocation == MenuLocation.Sidebar ? 'sm' : 'md'}>
                    Donor Actions
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {menuItems.map((item, index) => {
                        if (item.action == DonorAction.Divider) {
                            return (
                                <MenuItem key={'divider-' + index} divider />
                            );
                        }
                        return (
                            <MenuItem key={'action-' + index} eventKey={item.action}>{item.title}</MenuItem>
                        );
                    })}
                </Dropdown.Menu>
            </Dropdown>
        );
    }

    return (
        <div style={{ width: '100%', textAlign: 'center' }}>
            <OverlayMenuButton
                menu={menu}
                bsStyle='primary'
                bsSize='xs'
                title='Actions'
                listItemStyle={{ padding: '2px 7.5px', fontSize: 14 }}
                includeCaret={true}
                width={300}
                onToggle={handleMenuToggle}
                onSelect={handleMenuSelection}
            />
        </div>
    );
}

export default ActionButtonRenderer;